<template>
  <div>
    <h1>Payment Confirming...</h1>
    <form v-if="threeSecureRedirectMethod === 'POST'" ref="redirectForm" :action="threeSecureRedirectUrl" method="POST">
    </form>
  </div>
</template>

<script>
export default {
  name: 'PaymentConfirm',
  props: {
    threeSecureRedirectMethod: String,
    threeSecureRedirectUrl: String,
  },
  mounted() {
    if (this.threeSecureRedirectMethod === 'POST') {
      this.$refs.redirectForm.submit();
    } else if (this.threeSecureRedirectMethod === 'GET') {
      window.location.href = this.threeSecureRedirectUrl;
    }
  }
};
</script>